import React, { ReactNode } from 'react';

import styles from './PlaceholderSlide.module.scss';

function PlaceholderSlide({ children }: { children: ReactNode }) {
  return (
    <div className={styles.PlaceholderSlide}>
      <div className={styles.PlaceholderSlide__activity}>{children}</div>
    </div>
  );
}

export default PlaceholderSlide;
